module.exports = __webpack_public_path__ + "static/media/gse.fc303074.png";